import 'css-chunk:src/index/pages/account_register/index.module.scss';export default {
  "tablet": "tablet__ZoMej",
  "sp": "sp__7FO3o",
  "pc": "pc__rCVxP",
  "pcTablet": "pcTablet__1qqSQ",
  "section": "section__mv-Vp",
  "relative": "relative__oYewG",
  "row": "row__-LLCU",
  "middle": "middle__Zyfdv",
  "formLabel": "formLabel__HcdWB",
  "formLabel2": "formLabel2__szbyW",
  "formLabelIssue": "formLabelIssue__P-g8E",
  "section_no_backcolor": "section_no_backcolor__ZaA1f",
  "hoge": "hoge__Hziev",
  "row2": "row2__Gb4es",
  "item": "item__JPIm1",
  "inputWidth": "inputWidth__rgtN3",
  "space_bottom": "space_bottom__plyE7",
  "width_max": "width_max__meQcq",
  "required": "required__Gf9Py",
  "form_custom": "form_custom__0798i",
  "form_custom_child": "form_custom_child__y7NrX",
  "space": "space__paXl9",
  "space_left": "space_left__zD1bB",
  "form": "form__s90Dv",
  "table": "table__Vpl12",
  "register_button": "register_button__Chwrh",
  "error": "error__nD6Md",
  "role_explan_list": "role_explan_list__k06Do"
};